<template>
  <div class="ele-body">
    <el-card shadow="never">
      <ele-pro-table
        ref="table"
        :datasource="url"
        :columns="columns"
        height="calc(100vh - 260px)">
        <template slot="toolbar">
          <el-button
            size="small"
            type="warning"
            icon="el-icon-refresh"
            class="ele-btn-icon"
            @click="initData"
            v-if="permission.includes('sys:balance:index')">初始化</el-button>
        </template>
        <template slot="action" slot-scope="{ row }">
          <el-button
            size="small"
            type="primary"
            class="ele-btn-icon"
            :loading="syncingId === row.id"
            @click="syncBalance(row)"
            v-if="permission.includes('sys:balance:index')">同步</el-button>
        </template>
      </ele-pro-table>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ChannelBalance',
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/channelbalance/index',
      syncingId: 0,
      columns: [
        { prop: 'id', label: '序号', width: 70, align: 'center' },
        { prop: 'upName', label: '上游名称', minWidth: 160, align: 'center', showOverflowTooltip: true },
        { prop: 'balance', label: '余额', minWidth: 120, align: 'center' },
        { prop: 'blockedbalance', label: '冻结', minWidth: 120, align: 'center' },
        { columnKey: 'action', label: '操作', width: 100, align: 'center', slot: 'action', fixed: 'right' }
      ]
    };
  },
  methods: {
    reload() {
      this.$refs.table.reload();
    },
    initData() {
      this.$confirm('初始化将清空全部上游余额且不可恢复，确定继续？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/channelbalance/initData').then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    syncBalance(row) {
      if (!row || !row.id || this.syncingId) {
        return;
      }
      this.syncingId = row.id;
      this.$http.post('/channelbalance/saveTongbu', { id: row.id }).then((res) => {
        this.syncingId = 0;
        if (res.data.code === 0) {
          this.$message.success(res.data.msg || '同步成功');
          this.reload();
          return;
        }
        this.$message.error(res.data.msg || '同步失败');
      }).catch((e) => {
        this.syncingId = 0;
        this.$message.error(e.message);
      });
    }
  }
};
</script>
